import Firebase from 'firebase'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'

import Words from '../data/words'
import { prepareForUpdate } from '../data/db_util'

const startGame = ({players, game}) => {
  ReactGA.event({
    category: 'Game',
    action: 'Started a game',
  })

  const playersSortedByRandomSeed = players.map(p => {
    p.seed = Math.random()
    return p
  }).sort( (a, b) => {
    return a.seed < b.seed ? -1 : 1
  })

  const playersWithTargetAndRandomWord = playersSortedByRandomSeed.map( (player, index, players) => {
    if (index >= players.length - 1) {
      player.target = players[0].user
    } else {
      player.target = players[index + 1].user
    }
    player.poisonWord = Words[Math.floor(Math.random() * Words.length)]
    return player
  })

  const batch = Firebase.firestore().batch()
  var playersRef = Firebase.firestore().collection('players')
  playersWithTargetAndRandomWord.forEach( player => {
    batch.update(playersRef.doc(player.id), prepareForUpdate(player))
  })
  return batch.commit().then( () => {
    game = Object.assign({}, game, {started: true})
    return Firebase.firestore().collection('games').doc(game.id).set(game).then( () => {
      toast('The game has started!')
    })
  }).catch( error => {
    console.error(`Couldn't update players in game ${game.id}: ${error.message}`)
    toast.error(`Sorry, couldn't start the game--try again in a minute?`)
  })

}

export default startGame



// WEBPACK FOOTER //
// ./src/actions/startGame.js